import { SecretSubmissionForm } from 'src/components/SecretSubmissionForm.js';

export function Home() {
  return (
    <>
      <SecretSubmissionForm />
    </>
  );
}
